'use strict';

// Making these GTM utility functions available globally
// (might be useful elsewhere in the future)
window.gtag = function () {
  dataLayer.push(arguments);
};
const updateConsent = (newConsentStates) => {
  window.gtag('consent', 'update', newConsentStates);
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var CookieMessage = /*#__PURE__*/ (function () {
  function CookieMessage(wrapper) {
    _classCallCheck(this, CookieMessage);

    this.wrapper = wrapper;
    this.closingButtons = wrapper.querySelectorAll('.cookie-message__close');
    this.localStorageKey = 'cookie';
    this.init();
  }

  _createClass(CookieMessage, [
    {
      key: 'closeBar',
      // Function to close the cookie message bar and update consent settings
      // Triggered by setListeners for the closing buttons below
      value: function closeBar(event) {
        this.wrapper.classList.remove('cookie-message--open');
        var isDeniedButton = event.currentTarget.classList.contains(
          'cookie-message__deny'
        );

        if (isDeniedButton) {
          // GTM will push updated consent settings on every page load if this localStorage key is set to 'denied'
          localStorage.setItem(this.localStorageKey, 'denied');
          updateConsent({
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            personalization_storage: 'denied',
            functionality_storage: 'denied',
            security_storage: 'denied',
          });
        } else {
          // GTM will NOT do anything (default == 'granted') when localStorage key is set to 'closed'
          localStorage.setItem(this.localStorageKey, 'closed');
        }
      },
    },
    {
      key: 'setListeners',
      // Set event listeners for closing buttons to trigger closeBar function
      value: function setListeners() {
        var _this = this;

        this.closingButtons.forEach(function (el) {
          el.addEventListener('click', (e) => _this.closeBar(e));
        });
      },
    },
    {
      key: 'init',
      // Initialize this class
      value: function init() {
        // Display message if it wasn't closed before
        var currentSetting = localStorage.getItem(this.localStorageKey);
        if (currentSetting !== 'closed' && currentSetting !== 'denied') {
          this.wrapper.classList.add('cookie-message--open');
          this.setListeners();
        }

        // Push updated consent settings to GTM if cookie was denied before
        if (localStorage.getItem(this.localStorageKey) === 'denied') {
          updateConsent({
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            personalization_storage: 'denied',
            functionality_storage: 'denied',
            security_storage: 'denied',
          });
        } // Else, we do nothing - default 'granted' is set by GTM script
      },
    },
  ]);

  return CookieMessage;
})();

define(function () {
  return function (config, element) {
    new CookieMessage(element);
  };
});
//# sourceMappingURL=cookie-message.babel.js.map
